/* Zurie — modules de conversion (offres par quantité, sticky, compte à rebours, upsell) */
(() => {
  const formatMoney = (cents, format) => {
    const value = (cents / 100);
    const fmt = (n, dec, thou, decSep) =>
      n.toFixed(dec).replace(/\B(?=(\d{3})+(?!\d))/g, '\u0001').split('.').join(decSep).split('\u0001').join(thou);
    return (format || '{{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount_no_decimals': return fmt(Math.round(value), 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(Math.round(value), 0, '.', ',');
        case 'amount_with_space_separator': return fmt(value, 2, ' ', ',');
        default: return fmt(value, 2, ',', '.');
      }
    });
  };

  const currentVariantId = (formId) => {
    const form = document.getElementById(formId);
    const input = form && form.querySelector('input[name="id"]');
    return input ? input.value : null;
  };

  /* Bouton COD Releasit de la fiche produit (jamais celui du panier ni du bouton collant) */
  const findCod = () => {
    const all = [...document.querySelectorAll('#rsi_buy_now_button, .rsi_buy_now_button, ._rsi-buy-now-button button')]
      .filter((b) => !b.closest('#cart-wrapper, cart-drawer, .cart-drawer, .drawer, zurie-sticky-atc'));
    return all.find((b) => b.offsetParent !== null) || all[0] || null;
  };
  window.zurieFindCod = findCod;

  /* ---------- Offres par quantité ---------- */
  class ZurieQuantityBreaks extends HTMLElement {
    connectedCallback() {
      this.formId = this.dataset.formId;
      this.moneyFormat = this.dataset.moneyFormat;
      try {
        this.prices = JSON.parse(this.querySelector('[data-variant-prices]').textContent);
      } catch (e) { this.prices = {}; }

      this.addEventListener('change', (e) => {
        if (e.target.matches('input[type="radio"]')) this.select(e.target);
      });
      const checked = this.querySelector('input:checked') || this.querySelector('input');
      if (checked) { checked.checked = true; this.select(checked); }

      const onVariant = () => this.refreshPrices();
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsub = subscribe(PUB_SUB_EVENTS.variantChange, () => setTimeout(onVariant, 50));
      }
      const form = document.getElementById(this.formId);
      if (form) form.addEventListener('change', onVariant);
    }

    disconnectedCallback() { if (this.unsub) this.unsub(); }

    quantityInput() {
      const form = document.getElementById(this.formId);
      if (!form) return null;
      let input = document.querySelector(`input[name="quantity"][form="${this.formId}"]`) || form.querySelector('input[name="quantity"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'quantity';
        form.appendChild(input);
      }
      return input;
    }

    select(radio) {
      this.querySelectorAll('.zqb__offer').forEach((el) => el.classList.toggle('is-selected', el.contains(radio)));
      const input = this.quantityInput();
      if (input) {
        input.value = radio.value;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      document.dispatchEvent(new CustomEvent('zurie:quantity', { detail: { quantity: Number(radio.value), discount: Number(radio.dataset.discount || 0) } }));
    }

    refreshPrices() {
      const id = currentVariantId(this.formId);
      const entry = this.prices[id];
      if (entry == null) return;
      const unit = Array.isArray(entry) ? entry[0] : entry;
      const compareUnit = Math.max(Array.isArray(entry) ? entry[1] : unit, unit);
      this.querySelectorAll('.zqb__offer').forEach((offer) => {
        const radio = offer.querySelector('input');
        const qty = Number(radio.value);
        const disc = Number(radio.dataset.discount || 0);
        const amount = Number(radio.dataset.amount || 0);
        const full = unit * qty;
        const final = amount > 0 ? full - amount : Math.round(full * (100 - disc) / 100);
        const compare = compareUnit * qty;
        const f = offer.querySelector('[data-final]');
        const c = offer.querySelector('[data-full]');
        const sv = offer.querySelector('[data-saving]');
        if (f) f.textContent = formatMoney(final, this.moneyFormat);
        if (c) c.textContent = formatMoney(compare, this.moneyFormat);
        if (sv) sv.textContent = formatMoney(compare - final, this.moneyFormat);
      });
    }
  }
  if (!customElements.get('zurie-quantity-breaks')) customElements.define('zurie-quantity-breaks', ZurieQuantityBreaks);

  /* ---------- Compte à rebours ---------- */
  class ZurieCountdown extends HTMLElement {
    connectedCallback() {
      this.end = this.computeEnd();
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
    computeEnd() {
      if (this.dataset.mode === 'midnight') {
        const d = new Date(); d.setHours(23, 59, 59, 999); return d.getTime();
      }
      const hours = Number(this.dataset.hours || 2);
      const key = 'zurie-countdown-end';
      let end = null;
      try { end = Number(sessionStorage.getItem(key)); } catch (e) {}
      if (!end || end < Date.now()) {
        end = Date.now() + hours * 3600 * 1000;
        try { sessionStorage.setItem(key, String(end)); } catch (e) {}
      }
      return end;
    }
    tick() {
      let left = Math.max(0, this.end - Date.now());
      if (left === 0) { this.end = this.computeEnd(); left = this.end - Date.now(); }
      const s = Math.floor(left / 1000);
      const pad = (n) => String(n).padStart(2, '0');
      this.querySelector('[data-h]').textContent = pad(Math.floor(s / 3600));
      this.querySelector('[data-m]').textContent = pad(Math.floor((s % 3600) / 60));
      this.querySelector('[data-s]').textContent = pad(s % 60);
    }
  }
  if (!customElements.get('zurie-countdown')) customElements.define('zurie-countdown', ZurieCountdown);

  /* ---------- Bouton collant ---------- */
  class ZurieStickyAtc extends HTMLElement {
    connectedCallback() {
      /* Sorti du conteneur animé (transform) pour rester vraiment fixé en bas de l'écran */
      if (this.parentElement !== document.body && !(window.Shopify && Shopify.designMode)) {
        document.body.appendChild(this);
        return;
      }
      if (this.ready) return;
      this.ready = true;
      this.sectionId = this.dataset.sectionId;
      this.removeAttribute('hidden');
      this.querySelector('.zsticky__button').addEventListener('click', () => this.trigger());

      const anchor = document.getElementById('buttonContainerProduct') ||
        document.querySelector(`#MainProduct-${this.sectionId} .product-form`) ||
        document.getElementById(`price-${this.sectionId}`);
      const update = () => {
        const passed = anchor ? anchor.getBoundingClientRect().bottom < 0 : window.scrollY > 600;
        this.classList.toggle('is-visible', passed);
      };
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsub = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          const v = data && data.variant;
          const price = this.querySelector('[data-sticky-price]');
          const btn = this.querySelector('.zsticky__button');
          if (!v) return;
          btn.disabled = !v.available;
          const src = document.querySelector(`#price-${this.sectionId} .price-item--last, #price-${this.sectionId} .price-item--regular`);
          if (src && price) price.textContent = src.textContent.trim();
        });
      }
    }
    trigger() {
      const cod = findCod();
      if (cod) { cod.click(); return; }
      const extra = (this.dataset.target || '').split(',').map((s) => s.trim()).filter(Boolean);
      for (const sel of extra) {
        let el = null;
        try { el = document.querySelector(sel); } catch (e) {}
        if (el && !el.closest('zurie-sticky-atc')) { el.click(); return; }
      }
      /* Formulaire COD pas encore chargé : on remonte à l'offre au lieu d'ajouter au panier en silence */
      const zone = document.querySelector('.zqb') || document.getElementById(`MainProduct-${this.sectionId}`);
      if (zone) zone.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
  if (!customElements.get('zurie-sticky-atc')) customElements.define('zurie-sticky-atc', ZurieStickyAtc);

  /* ---------- Atouts à côté de la photo : même hauteur que la photo principale ---------- */
  const syncSideFeatures = () => {
    document.querySelectorAll('.zp-features--side').forEach((f) => {
      if (f.dataset.synced) return;
      const wrap = f.closest('.product__media-wrapper');
      const main = wrap && wrap.querySelector('.product__media-list');
      if (!main) return;
      f.dataset.synced = '1';
      const mq = window.matchMedia('(max-width: 749px)');
      const apply = () => { f.style.height = mq.matches ? `${Math.round(main.getBoundingClientRect().height)}px` : ''; };
      apply();
      if ('ResizeObserver' in window) new ResizeObserver(apply).observe(main);
      window.addEventListener('resize', apply);
      window.addEventListener('load', apply);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncSideFeatures);
  else syncSideFeatures();

  /* ---------- Boutons des sections -> formulaire COD ---------- */
  document.addEventListener('click', (e) => {
    const link = e.target.closest('.zs a[href="#MainContent"]');
    if (!link) return;
    const cod = findCod();
    if (cod) { e.preventDefault(); cod.click(); }
  });

  /* ---------- Synchronise l'offre choisie avec le formulaire Releasit ---------- */
  document.addEventListener('click', (e) => {
    if (!e.target.closest('#rsi_buy_now_button')) return;
    const radios = [...document.querySelectorAll('.zqb input[type="radio"]')];
    const idx = radios.findIndex((r) => r.checked);
    if (idx < 0) return;
    let tries = 0;
    const pick = () => {
      const labels = [...document.querySelectorAll('label.rsi-quantity-product')].filter((l) => l.offsetParent !== null);
      if (labels.length > idx) {
        const input = labels[idx].querySelector('input');
        if (!input || !input.checked) labels[idx].click();
        return;
      }
      if (++tries < 30) setTimeout(pick, 100);
    };
    setTimeout(pick, 50);
  }, true);

  /* ---------- Upsell ---------- */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-zurie-upsell]');
    if (!btn || btn.disabled) return;
    const label = btn.textContent;
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    try {
      const res = await fetch(`${(window.routes && window.routes.cart_add_url) || '/cart/add'}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(btn.dataset.zurieUpsell), quantity: 1 }] }),
      });
      if (!res.ok) throw new Error('add failed');
      btn.textContent = '✓';
      btn.classList.add('is-added');
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'zurie-upsell' });
      }
      fetch('/cart.js').then((r) => r.json()).then((cart) => {
        document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]').forEach((el) => { el.textContent = cart.item_count; });
      }).catch(() => {});
    } catch (err) {
      btn.textContent = label;
      btn.disabled = false;
    } finally {
      btn.removeAttribute('aria-busy');
    }
  });
})();
